// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2-EZy","label":"Radio_label__1HheP","checkMark":"Radio_checkMark__3tTBu","disabled":"Radio_disabled__1Ldlb"};